// extracted by mini-css-extract-plugin
module.exports = {"page":"DeclarationPage-module__page___3-aFD","page-margin":"DeclarationPage-module__page-margin___2zl6T","pageMargin":"DeclarationPage-module__page-margin___2zl6T"};